import { render, staticRenderFns } from "./LargasUsados.vue?vue&type=template&id=7618bd80&scoped=true&"
import script from "./LargasUsados.vue?vue&type=script&lang=js&"
export * from "./LargasUsados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7618bd80",
  null
  
)

export default component.exports